class ProductMulticolumn extends HTMLElement{
    constructor(){
        super()
        this.subscriptionSelects = this.querySelectorAll(".select--subscription");
    }

    connectedCallback() {
       this.initSubscriptionSelects();  
    }
    initSubscriptionSelects(){
         if(this.subscriptionSelects) {
            this.subscriptionSelects.forEach((select) => {
                const dataset = select.dataset;
                const form = this.querySelector(`#product-form-${dataset.productId}${dataset.variantId}`);
                if(!form) return;
                const input = form.querySelector(`input[name="selling_plan"`);
                if(!input) return;
                const variantWrapper = this.querySelector(`.variant-wrapper[data-variant-id="${dataset.variantId}"]`);
                if(dataset.preselectSub === "true") {
                    this.toggleSubscription(true, input, dataset, variantWrapper);
                }
                select.addEventListener("change", (e) => {
                    this.toggleSubscription(e.target.value === "subscribe", input, dataset, variantWrapper);
                });
            })
        }        
    }
    toggleSubscription(active, input, dataset, variantWrapper) {        
        input.value = active ? dataset.sellingPlan : null;
         
        const pricePerUnitDiv = variantWrapper.querySelector(".price-per-unit");
        let subPricePerUnitDiv = variantWrapper.querySelector(".price-per-unit.subscription");

        const currentPriceDiv = variantWrapper.querySelector("sale-price.text-on-sale .regular-price");
        let subCurrentPriceDiv = variantWrapper.querySelector("price-list .subscription-price");

        const discountDiv = variantWrapper.querySelector(".discount .percent");
        let subDiscountDiv = variantWrapper.querySelector(".discount .percent.subscription");

        const regularPriceDiv = variantWrapper?.querySelector("sale-price.text-subdued .regular-price");
        let subRegularPriceDiv = variantWrapper?.querySelector(".price-list .subscription-price");

        if(active !== true) {
            // regular price
            
            if(regularPriceDiv && subRegularPriceDiv) {
                regularPriceDiv.classList.remove("hidden");
                subRegularPriceDiv.classList.add("hidden");
            }

            // Price per unit
            pricePerUnitDiv?.classList.remove("hidden");
            subPricePerUnitDiv?.classList.add("hidden");

            // Total price
            currentPriceDiv?.classList.remove("hidden");
            subCurrentPriceDiv?.classList.add("hidden");

            // Discount percentage
            discountDiv?.classList.remove("hidden");
            subDiscountDiv?.classList.add("hidden");
            
            return;
        }
     
        if(regularPriceDiv && subRegularPriceDiv) {
            regularPriceDiv.classList.add("hidden");
            subRegularPriceDiv.classList.remove("hidden");
        }

        // Price per unit
        const pricePerUnit = dataset.productSubPricePi;
        
        if(pricePerUnitDiv && !subPricePerUnitDiv) {
            this.renderSubscriptionPrice(pricePerUnitDiv, `<span class="price-per-unit subscription-price">${pricePerUnit}</span>`);
            subPricePerUnitDiv = variantWrapper.querySelector(".price-per-unit.subscription-price");
        }

        pricePerUnitDiv?.classList.add("hidden");
        subPricePerUnitDiv?.classList.remove("hidden");
        
        // Total price
        const currentPrice = dataset.productSubPrice;
    
        if(currentPriceDiv && !subCurrentPriceDiv) {
            this.renderSubscriptionPrice(currentPriceDiv, `<span class="subscription-price">${currentPrice}</span>`);
            subCurrentPriceDiv = variantWrapper.querySelector("price-list .subscription-price");
        }

        currentPriceDiv?.classList.add("hidden");
        subCurrentPriceDiv?.classList.remove("hidden");

        // Discount percentage
        const discountPercentage = Math.floor((this.cleanPrice(dataset.compareAtPrice) - this.cleanPrice(dataset.productSubPrice)) / this.cleanPrice(dataset.compareAtPrice) * 100);
        if(discountDiv && !subDiscountDiv) {
            this.renderSubscriptionPrice(discountDiv, `<span class="percent subscription">${discountPercentage}%</span>`);
            subDiscountDiv = variantWrapper.querySelector(".discount .percent.subscription");
        }

        discountDiv?.classList.add("hidden");
        subDiscountDiv?.classList.remove("hidden");
    }

    renderSubscriptionPrice(targetElement, innerHTML) {
        const newElement = document.createElement("div");
        newElement.innerHTML = innerHTML;
        targetElement.insertAdjacentHTML("afterend", innerHTML);
    }

    cleanPrice(priceString){
        return priceString.replace(/[^0-9.-]+/g, "");
    }
}
customElements.define("product-multicolumn", ProductMulticolumn)
